import {mapMutations, mapGetters} from "vuex";
import {rePostionContents, reSizeIeBackground, reSizeBackground} from "@/utils/cavasResize";

import Detail from "@/components/TheDetail";
import Slide from "@/components/TheSlide"

export default{
    data() {
        return {
            w:0,
            h:0,
            canvas: null,
            cvObj: {},
            cvFilters:{},
            contentSize:{w:1920, h:1080},
            enterMotion: null,
            leaveMotion: null
        };
    },
    computed:{
        ...mapGetters([
          'activeLayer',
          'documentSize',
          'pageArrow',
        ])
    },
    components:{
        Detail,
        Slide
    },
    methods: {
        ...mapMutations([
            'changePage',
            'isMovePage',
            'isLayerView',
            'documentSetSize',
        ]),
        baseCavasSet(option){
            if(this.documentSize.width == 0){
                this.documentSetSize({
                    width: document.querySelector('.container').clientWidth,
                    height:document.querySelector('.container').clientHeight
                });
            }
            this.w = this.documentSize.width;
            this.h = this.documentSize.height;
            this.canvas = new PIXI.Application(this.w, this.h, {transparent:true, autoStart:true}); //forceCanvas:true
            this.$el.querySelector('.bg').appendChild(this.canvas.view);
            option.forEach(obj=>{
                let type = obj.type;
                switch(type) {
                    case 'bg': {
                        if(obj.objName == 'bg'){
                            this.cvObj.bg = PIXI.Sprite.fromImage(obj.source);
                        }else{
                            // if(!this.$isIe11){
                                // this.cvObj.video = document.createElement('video');
                                // this.cvObj.video.src = obj.source;
                                // this.cvObj.video.autoplay  = false;
                                // this.cvObj.video.loop = true;

                            //     this.cvObj.bgTexture = PIXI.Texture.fromVideo(obj.source);
                            //     this.cvObj.bgTexture.baseTexture.source.loop = true;
                            //     this.cvObj.bgTexture.baseTexture.source.muted = true;
                            //     let conAreaBg = new PIXI.Graphics(0, 0);
                            //     conAreaBg.alpha = 0;
                            //     conAreaBg.drawRect(0, 0, this.w, this.h);
                            //
                            //
                            //     this.cvObj.bg = new PIXI.Sprite(this.cvObj.bgTexture);
                            //     this.cvObj.bg.addChild(conAreaBg);
                            //
                            // }else{
                            //     this.cvObj.ieBg = document.createElement('video');
                            //     this.cvObj.ieBg.src = obj.source;
                            //     this.cvObj.ieBg.mute = true;
                            //     this.cvObj.ieBg.autoPlay = true;
                            //     this.cvObj.ieBg.loop = true;
                            //
                            //     this.cvObj.ieBg.addEventListener('canplay', ()=>{
                            //         this.cvObj.ieBg.pause();
                            //         this.cvObj.ieBg.play();
                            //     })
                            this.cvObj.bg = new PIXI.Container();
                            let conAreaBg = new PIXI.Graphics(0, 0);
                            conAreaBg.beginFill(0x000000);
                            conAreaBg.alpha = 0;
                            conAreaBg.drawRect(0, 0, this.w, this.h);
                            conAreaBg.endFill();
                            this.cvObj.bg.addChild(conAreaBg);

                           this.cvObj.videoCon = document.createElement('div');
                           this.cvObj.videoCon.className= "bg-player";
                           this.cvObj.videoCon.id= `videoBg_${this.name}`;
                           this.$el.insertBefore(this.cvObj.videoCon, this.$el.querySelector('.bg'));
                                this.cvObj.videoBg = new nc.promokit.Player({
                                    selector: `#videoBg_${this.name}`,
                                    videoId: obj.source,
                                    mute: true,
                                    controls: false,
                                    coverClick: false,
                                    loop: true,
                                    autoPlay:true
                                });

                           // }
                        }
                        reSizeBackground(this.cvObj.bg, this.w, this.h);
                        this.canvas.stage.addChild(this.cvObj.bg);

                        // this.cvFilters.OldFilmFilter =  new PIXI.filters.OldFilmFilter(0.1+Math.random()*0.1);
                        // this.cvFilters.OldFilmFilter.sepia = 0;
                        // this.cvFilters.OldFilmFilter.noise  = 0.5;
                        // this.cvFilters.OldFilmFilter.scratchWidth  = 1;
                        // this.cvFilters.OldFilmFilter.vignettingAlpha  = 1;
                        // this.canvas.stage.filters = [this.cvFilters.OldFilmFilter];

                        this.cvObj.con = new PIXI.Container();
                        this.cvObj.con.x = this.w/2 - this.contentSize.w/2;
                        this.cvObj.con.y = 0;
                        this.canvas.stage.addChild(this.cvObj.con);
                        let conArea = new PIXI.Graphics(this.w/2 - this.contentSize.w/2, 0);
                        conArea.alpha = 0;
                        conArea.drawRect(0, 0, this.contentSize.w, this.contentSize.h);
                        this.cvObj.con.addChild(conArea);

                        break;
                    }
                    case 'chr': {
                        this.cvObj[obj.objName+'Con'] = new PIXI.Container();
                        this.cvObj.con.addChild(this.cvObj[obj.objName+'Con']);

                        this.cvObj[obj.objName] = new PIXI.Sprite.fromImage(obj.source);
                        this.cvObj[obj.objName].x = obj.x;
                        this.cvObj[obj.objName].y = obj.y;
                        this.cvObj[obj.objName+'Con'].addChild(this.cvObj[obj.objName]);
                        break;
                    }
                    case 'txt': {
                        this.cvObj[obj.objName] = new PIXI.Sprite.fromImage(obj.source);
                        this.cvObj[obj.objName].x = obj.x;
                        this.cvObj[obj.objName].y = obj.y;
                        this.cvObj.con.addChild(this.cvObj[obj.objName]);
                        break;
                    }
                    case 'btn': {
                        this.cvObj[obj.objName] = new PIXI.Sprite.fromImage(obj.source);
                        this.cvObj[obj.objName].x = obj.x;
                        this.cvObj[obj.objName].y = obj.y;
                        this.cvObj[obj.objName].name = obj.objName;
                        this.cvObj[obj.objName].interactive = true;
                        this.cvObj[obj.objName].cursor = 'pointer';
                        this.cvObj[obj.objName].pointerdown = (e)=>{
                            this.openLayer(e)
                        };
                        this.cvObj[obj.objName].pointerover = function(e){
                            TweenMax.to(this, 0.5, { pixi: { brightness : 1.5 }})
                        };
                        this.cvObj[obj.objName].pointerout = function(e){
                            TweenMax.to(this, 0.2, { pixi: { brightness : 1 }})
                        };

                        this.cvObj.con.addChild(this.cvObj[obj.objName]);
                        break;
                    }
                }
            });

            this.canvas.ticker.add(()=> {
                //this.cvFilters.OldFilmFilter.speed = Math.random();
             });


         },
        baseEnterMotion(el, done, option){
            let startScale = 1.5;
            if(this.pageArrow === 'prev')startScale = 1;
            this.enterMotion = new TimelineLite({onComplete:done, paused:true});

            option.forEach(obj=> {
                let type = obj.type;
                let delay, arrow;
                switch (type) {
                    case 'bg': {
                        TweenMax.set(this.cvObj.videoCon, {alpha: 0, scale:startScale});
                        //if(this.cvObj.ieBg)TweenMax.set(this.cvObj.ieBg, {autoAlpha: 0 });
                        this.enterMotion
                           // .to(this.cvFilters.OldFilmFilter,1.5, {sepia:0, noise:0, vignettingAlpha:0, scratchDensity:0, ease:Cubic.easeIn},'+=0.5')
                            .to(this.cvObj.videoCon, 1, {alpha: 1,scale:1, ease: Power1.easeOut},'+=0.05')
                            .call(()=>{this.isMovePage(false);}, null, null)
                            .addLabel('bgMotionEnd')
                            // if(this.cvObj.ieBg){
                            //     this.enterMotion.to(this.cvObj.ieBg, 2,{autoAlpha: 1 }, 'bgMotionEnd-=1.5')
                            // }
                        break;
                    }
                    case 'chr': {
                        delay = obj.delay? obj.delay : '-=0.5';
                        arrow = obj.arrow? obj.arrow : -200;
                        TweenMax.set(this.cvObj[obj.objName], {x:obj.x+arrow, pixi: { alpha: 0 , brightness: 2} })
                       // TweenMax.set(this.cvObj[obj.objName + 'Con'], {pixi: {blurY: 30} })
                        this.enterMotion
                            .to(this.cvObj[obj.objName], 1, {x:obj.x, pixi: {alpha: 1, brightness: 2}, ease: Cubic.easeOut}, delay)
                            .to(this.cvObj[obj.objName], 0.5, {x:obj.x, pixi: { brightness: 1}, ease: Cubic.easeInOut})
                           // .to(this.cvObj[obj.objName + 'Con'], 2, {pixi: {blurY:0}, ease: Power1.easeInOut}, '-=2')
                        break;
                    }
                    case 'txt': {
                        if(obj.objName == 'obj_tit'){
                            delay = obj.delay? obj.delay : '-=1';
                            TweenMax.set(this.cvObj[obj.objName], {pixi: { alpha: 0 , brightness: 2} })
                            this.enterMotion.to(this.cvObj[obj.objName], 1, { pixi: { alpha: 1, brightness: 1}, ease: Quart.easeOut}, delay)
                        }
                        if(obj.objName == 'obj_stit'){
                            TweenMax.set(this.cvObj[obj.objName], {y:obj.y+30, pixi: { alpha: 0} })
                            this.enterMotion.to(this.cvObj[obj.objName], 1, {y:obj.y, pixi: { alpha: 1}, ease: Quart.easeOut}, '-=0.8')
                        }
                        if(obj.objName == 'obj_txt'){
                            TweenMax.set(this.cvObj[obj.objName], {y:obj.y+30, pixi: { alpha: 0} })
                            this.enterMotion.to(this.cvObj[obj.objName], 1, {y:obj.y, pixi: { alpha: 1}, ease: Quart.easeOut}, '-=0.8')
                        }
                        break;
                    }
                    case 'btn': {
                        TweenMax.set(this.cvObj[obj.objName], {pixi: { alpha: 0 , brightness: 5} })
                        this.enterMotion
                            .to(this.cvObj[obj.objName], 1, {y:obj.y, pixi: { alpha: 1, brightness: 1}, ease: Quart.easeOut}, '-=0.8')
                        break;
                    }
                }
            });
            //GSDevTools.create({paused:true, id:this.name});
        },
        baseLeaveMotion(el, done){
            let endScale = 1;
            if(this.pageArrow === 'prev')endScale = 1.5;

            this.cvObj.videoBg.stop();


            this.leaveMotion = new TimelineLite({onComplete:()=>{
                    done();
                    this.canvas.stop();
                }
            });
            this.leaveMotion
                .to(this.$el, 1, {autoAlpha:0, scale:endScale, ease: Power1.easeOut})
        },
        baseEnter(){
            window.addEventListener('resize', this.resize);
            this.resize();
        },
        beforeEnter(el){
        },
        enter (el, done) {
            this.baseEnter();
        },
        leave (el, done) {

        },
        resize(){
            this.w =  document.querySelector('.container').clientWidth;
            this.h = document.querySelector('.container').clientHeight;
            if(!this.canvas)return;
            if(this.cvObj.ieBg){
                reSizeIeBackground(this.cvObj.ieBg, this.w, this.h);
            }
            reSizeBackground(this.cvObj.bg, this.w, this.h);
            rePostionContents(this.cvObj.con, this.w, this.h, this.contentSize.w, this.contentSize.h, true);
            this.canvas.renderer.resize(this.w, this.h);

            this.documentSetSize({
                width:this.w,
                height:this.h
            });
        },
        openLayer(e) {
            this.isLayerView(e.currentTarget.name);
        },
        handleTransitionStart() {
            this.layerData[this.activeLayer].index = this.$refs[this.activeLayer].now();
        },
        handleTransitionEnd() {
            this.layerData[this.activeLayer].index = this.$refs[this.activeLayer].now();
            window.nowPlayingVideo && window.nowPlayingVideo.stop();
        },
        handleClickTo(index) {
            this.$refs[this.activeLayer].to(index);
        },
    },
    mounted() {
        this.changePage(this.$options.name);
        this.isMovePage(true);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }
    // beforeRouteEnter  (to, from, next) {
    //     next();
    // },
    // beforeRouteLeave (to, from, next) {
    //     next();
    // }
}